import React, { useState } from "react";
import { useSelector } from "react-redux";
import { createSlug, formatPrice } from "../../../helpers";
import { Link, useNavigate } from "react-router-dom";
import CardTimer from "../../common/CardTimer";
import useTranslationHook from "../../hooks/useTranslationHook";
import VerifyAccountModal from "../../partials/property-details/right-panel/modals/VerifyAccountModal";
import { accountStatus } from "../../../utils/constants";
import { toast } from "react-toastify";

const LiveCard = ({ ele, syncData }) => {
    const slug = createSlug(
        ele?.property || ele?.id,
        `${ele?.property_name} ${ele?.country}`
    );
    const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
    const user = useSelector((state) => state.auth.user);
    const navigate = useNavigate();
    const [proeprtyCurrentStatus, setProeprtyCurrentStatus] = useState({
        label: "Loading...",
        className: "active",
    });
    const { t } = useTranslationHook();
    let lang = useSelector((state) => state.translation.lang);

    return (
        <>
            <li>
                <figure>
                    <img
                        className="slide-fixed"
                        src="img/trans-3x2.png"
                        alt=""
                    />
                    <img
                        className="slide-img"
                        src={`${process.env.REACT_APP_AZURE_BLOB_URL}${ele.property_image?.image && ele.property_image?.bucket_name ? `${ele.property_image.bucket_name}/${ele.property_image.image}` : "property_image/default_property.jpg"}`}
                        alt="Dicover Pic"
                    />

                    <div className="top">
                        <div className="status-info">
                            <span className="total-bid">
                                {t("discover card total bids", {
                                    totalBids: syncData?.bid_count || 0,
                                })}
                            </span>
                            <span className="status">
                                <em></em> {t("Live Room")}
                            </span>
                            {/* <span className={proeprtyCurrentStatus?.className}>
                            {proeprtyCurrentStatus?.label}
                        </span> */}
                        </div>
                    </div>
                    <div className="bottom">
                        <h6>
                            {lang === "en"
                                ? ele?.property_name
                                : ele?.property_name_ar || ""}
                        </h6>
                        <div className="bid-box">
                            <div className="high-bid">
                                <small>
                                    {syncData?.bid_count
                                        ? t("Highest Bid")
                                        : t("Starting Price")}
                                </small>
                                <h5>
                                    {syncData
                                        ? t("Amount", {
                                              amount: `${formatPrice(
                                                  syncData?.bid_count
                                                      ? syncData?.high_bid_amt
                                                      : syncData?.start_price,
                                                  lang
                                              )}`,
                                          })
                                        : t("Loading...")}
                                </h5>
                            </div>

                            {/* {syncData && (
                            <CardTimer
                                data={syncData}
                                onStatusChange={setProeprtyCurrentStatus}
                            />
                        )} */}
                        </div>
                        <div className="apk">
                            <div className="apk-text">
                                {t(ele?.property_type || "")} <span>|</span>
                                {t(ele?.construction_status_name || "")}
                            </div>
                            <Link
                                to={`/property/detail/${slug}`}
                                className="prp-link"
                            >
                                {t("Property Details")}
                                <i className="fa-solid fa-chevron-right"></i>
                            </Link>
                        </div>

                        <div className="timer">
                            <button
                                onClick={(e) => {
                                    if (!isAuthenticated) {
                                        navigate(
                                            `/sign-in?redirect=${encodeURIComponent(location.pathname)}`
                                        );
                                        return;
                                    }
                                    const isJoinRoom =
                                        ele?.is_registered &&
                                        ele?.is_payment_completed;

                                    const isVerified =
                                        user?.user_account_verification ===
                                            accountStatus?.success ||
                                        user?.is_account_verified ===
                                            accountStatus?.success;

                                    if (isJoinRoom && !isVerified) {
                                        toast.info(
                                            t(
                                                "Please verify your account before proceeding."
                                            )
                                        );
                                        navigate("/verify");
                                        return;
                                    }

                                    navigate(`/live-auction-details`, {
                                        state: {
                                            propertyId: ele?.property_id,
                                            selectedSessionID: ele?.session_id,
                                            lotID: ele?.lot_id,
                                        },
                                    });
                                }}
                                className="btn btn-white"
                            >
                                {/* {syncData?.my_max_bid_val
                                    ? t("Join the Room")
                                    : t("Watch Now")} */}
                                {ele?.is_registered && ele?.is_payment_completed
                                    ? t("Join the Room")
                                    : t("Watch Now")}
                            </button>
                        </div>
                    </div>
                </figure>
            </li>
        </>
    );
};

export default LiveCard;
